/**
 * QUE CUENTA COMO ESTABLE. Una sola lista, porque antes habia dos y no decian lo mismo.
 *
 * EL FALLO QUE ESTO ARREGLA (2026-08-18). `lib/precio.ts` preguntaba con una expresion regular y
 * `lib/puente.ts` con una lista escrita a mano, y cada una conocia monedas que la otra no. El caso
 * vivo era `USD₮0` —el USDT de Arbitrum y HyperEVM, que se escribe con el simbolo ₮ y no con una T
 * latina— y esta en las pools REALES de las dos cadenas: `precio.ts` lo reconocia y `puente.ts` no,
 * asi que el barrido de polvo no lo ofrecia como destino y nadie entendia por que faltaba. Al reves
 * tambien: `precio.ts` no conocia USDHL, USDE, FDUSD, LUSD, USDB ni USDC.E, y el dia que entre una
 * pool con uno de ellos habria elegido al reves cual es el activo y cual la referencia — eso ya no
 * es una opcion que falta, es dinero.
 *
 * SE NORMALIZA EL ₮. Cualquier simbolo pasa por `normaliza()` antes de compararse, asi que `USD₮0`
 * y `USDT0` son la misma moneda aqui. Es el unico caracter raro que hemos visto en produccion; si
 * aparece otro, se añade en un solo sitio.
 *
 * LA LISTA SIGUE SIENDO A MANO, y no «lo que lleve USD en el simbolo»: hay tokens con USD en el
 * nombre que no valen nada, y ofrecerlos como destino de todo el polvo de alguien es la peor
 * manera de enterarse.
 */
const ESTABLES = [
  "USDG", "USDC", "USDC.E", "USDBC", "USDT", "USDT0", "USDP", "USDS", "USDE",
  "DAI", "FDUSD", "USDB", "LUSD", "FRAX", "GHO", "PYUSD", "USDHL",
];

/** El ₮ (U+20AE) es una T. Ver la nota de arriba: es lo que separaba las dos listas. */
export const normaliza = (s?: string) => (s ?? "").replace(/₮/g, "T").toUpperCase();

/**
 * ¿Es un estable? Se usa para dos preguntas parecidas pero no iguales:
 *
 *  · CLASIFICAR EL PAR de una pool ya curada (`lib/precio.ts`) — cual de las dos monedas es la
 *    referencia y cual el activo que sube y baja.
 *  · OFRECER DESTINO al barrido de polvo (`lib/puente.ts`) — a que moneda se junta todo.
 *
 * Hoy la respuesta es la misma para las dos y por eso hay una sola lista. Si algun dia hace falta
 * que difieran, el sitio de hacerlo es aqui, con un subconjunto explicito y su motivo escrito —
 * no volviendo a tener dos listas en dos ficheros que nadie compara.
 */
export const esEstable = (simbolo?: string) => ESTABLES.includes(normaliza(simbolo));

export { ESTABLES };
